import React, { useEffect, useRef, useState } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { LanguageType } from '@/i18n'

type GeneralNoteProps = {
  generalNoteContent: string
  setIsOpenEditModal?: (isOpenEditModal: boolean) => void
  canEdit?: boolean
}

export const GeneralNote = ({ generalNoteContent, setIsOpenEditModal = () => {}, canEdit = false }: GeneralNoteProps) => {
  const { t, i18n } = useTranslation()
  const [hasMoreText, setHasMoreText] = useState<boolean>(false)
  const [isOpenNoteAccordion, setIsOpenNoteAccordion] = useState<boolean>(false)
  const noteRef = useRef<HTMLParagraphElement>(null)
  const defaultNoteLine = 3

  const initAccordion = () => {
    if (!noteRef || !noteRef.current) {
      return
    }
    const realNoteLineHeight = Number(
      getComputedStyle(noteRef.current)
        .getPropertyValue('line-height')
        .replace('px', ''),
    )
    setHasMoreText(noteRef.current.scrollHeight > defaultNoteLine * realNoteLineHeight)
    setIsOpenNoteAccordion(false)
  }

  useEffect(() => {
    initAccordion()
  }, [noteRef, generalNoteContent])

  return (
    <div css={containerStyle}>
      <div css={i18n.language === LanguageType.en ? headerNoteStyleEn : headerNoteStyle}>
        {t('cleaningManager.Notice')}
        {canEdit && <img css={editIconStyle} src={require(`@/static/images/edit.svg`)} onClick={() => setIsOpenEditModal(true)} />}
      </div>
      <div css={isOpenNoteAccordion ? noteBlockOpenStyle : noteBlockCloseStyle}>
        <p ref={noteRef}>{generalNoteContent}</p>
      </div>
      {hasMoreText &&
        (isOpenNoteAccordion ? (
          <div css={accordionTextStyle} onClick={() => setIsOpenNoteAccordion(false)}>
            <p>{t('Close up')}</p>
            <img
              style={{ transform: 'rotate(180deg)' }}
              src={require(`@/static/images/self-checkin-payment/arrow.svg`)}
              alt="up-arrow"
              width="16"
            />
          </div>
        ) : (
          <div css={accordionTextStyle} onClick={() => setIsOpenNoteAccordion(true)}>
            <p>{t('Show all')}</p>
            <img src={require(`@/static/images/self-checkin-payment/arrow.svg`)} alt="down-arrow" width="16" />
          </div>
        ))}
    </div>
  )
}

const containerStyle = css({
  borderRadius: '0 10px 10px 10px',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'flex-start',
})

const headerNoteStyle = css({
  width: '100%',
  position: 'relative',
  // padding: '24px 0 16px 0',
  padding: '24px 0 8px 0',
  fontSize: '18px',
  fontWeight: 'bold',
  letterSpacing: '2.7px',
  color: '#676767',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

const noteBlockCloseStyle = css({
  display: 'flex',
  margin: '0 auto',
  padding: '0 24px',
  width: '100%',
  height: '66px',
  p: {
    fontSize: '16px',
    letterSpacing: '1.6px',
    lineHeight: '22px',
    height: '100%',
    overflow: 'hidden',
    whiteSpace: 'pre-line',
  },
})
const headerNoteStyleEn = css(headerNoteStyle, {
  letterSpacing: '0.9px',
})

const noteBlockOpenStyle = css(noteBlockCloseStyle, {
  height: '100%',
})

const accordionTextStyle = css({
  padding: '11px 0 11px 0',
  alignSelf: 'center',
  alignItems: 'center',
  display: 'flex',
  cursor: 'pointer',
  color: '#f2a40b',
  P: {
    fontSize: 12,
  },
})

const editIconStyle = css({
  width: '28px',
  right: '24px',
  position: 'absolute',
  backgroundColor: '#f2f2f2',
  borderRadius: '100%',
  cursor: 'pointer',
})
